(function () {
  'use strict';
  if (window.ZeroPriceCartGuard) return;
  var active = null;
  var checkingOut = false;
  var replaying = false;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var message = 'Unable to verify your cart. Please try again before checking out.';

  function isZeroPrice(item) {
    // Missing prices must never be interpreted as zero.
    return ['price', 'final_price', 'line_price', 'final_line_price'].some(function (field) {
      return typeof item[field] === 'number' && item[field] === 0;
    });
  }

  async function request(path, options) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 12000);
    try {
      var response = await fetch(root + path, Object.assign({
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal
      }, options));
      if (!response.ok) throw new Error('Cart request failed: ' + response.status);
      var cart = await response.json();
      if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid cart response');
      return cart;
    } finally {
      clearTimeout(timer);
    }
  }

  async function removeItems() {
    var changed = false;
    // Re-read after every mutation: discounts and line keys can change.
    for (var pass = 0; pass < 4; pass++) {
      var cart = await request('cart.js');
      var gifts = cart.items.filter(isZeroPrice);
      if (!gifts.length) {
        document.querySelectorAll('.cart-item-count-bubble').forEach(function (element) {
          element.textContent = cart.item_count;
        });
        return { cart: cart, changed: changed };
      }
      if (pass === 3) throw new Error('Zero-price items are still being added');
      var updates = {};
      gifts.forEach(function (item) {
        if (!item.key) throw new Error('Missing cart line key');
        updates[item.key] = 0;
      });
      await request('cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
      changed = true;
    }
  }

  function clean() {
    if (!active) active = removeItems().finally(function () { active = null; });
    return active;
  }

  async function checkout(event, element, resume) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingOut) return;
    checkingOut = true;
    var previousBusy = element.getAttribute('aria-busy');
    element.setAttribute('aria-busy', 'true');
    try {
      if (active) await active;
      var result = await clean();
      if (!result.cart.items.length) {
        window.location.assign(root + 'cart');
        return;
      }
      // Preserve the original form/link and plugin handlers, including discounts.
      replaying = true;
      try { resume(); } finally { replaying = false; }
    } catch (error) {
      console.error('Zero-price cart cleanup:', error);
      window.alert(message);
    } finally {
      checkingOut = false;
      if (previousBusy === null) element.removeAttribute('aria-busy');
      else element.setAttribute('aria-busy', previousBusy);
    }
  }

  function isCheckoutUrl(value) {
    try {
      var url = new URL(value, window.location.href);
      return url.origin === window.location.origin && /\/checkout\/?$/.test(url.pathname);
    } catch (error) { return false; }
  }

  window.addEventListener('click', function (event) {
    if (replaying || !(event.target instanceof Element)) return;
    var element = event.target.closest('button[name="checkout"], input[name="checkout"], a[href], [data-zero-price-checkout]');
    if (!element || element.disabled) return;
    if (element.tagName === 'A' && !isCheckoutUrl(element.href)) return;
    if (element.form && !element.form.reportValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    checkout(event, element, function () { element.click(); });
  }, true);

  window.addEventListener('submit', function (event) {
    if (replaying) return;
    var form = event.target;
    var button = event.submitter;
    if (!isCheckoutUrl(form.action) && !(button && button.name === 'checkout')) return;
    checkout(event, form, function () {
      if (button) form.requestSubmit(button);
      else form.requestSubmit();
    });
  }, true);

  function cleanOnReturn() {
    if (checkingOut) return;
    clean().then(function (result) {
      if (!result.changed) return;
      if (typeof window.SLIDECART_UPDATE === 'function') window.SLIDECART_UPDATE();
      // The full cart contains quantity inputs and totals that require a fresh render.
      if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
    }).catch(function (error) { console.error('Zero-price cart cleanup:', error); });
  }

  window.ZeroPriceCartGuard = { clean: clean, isZeroPrice: isZeroPrice };
  window.cleanZeroPriceItems = clean;
  window.addEventListener('pageshow', cleanOnReturn);
  if (document.readyState === 'complete') cleanOnReturn();
})();
